import React from "react"
import { CircularProgress, Paper, Grid } from "@mui/material"
import { styled } from "@mui/material/styles"
import useApiLoading from "hooks/useApiLoading"

const ProgressPaper = styled(Paper)({
  position: "fixed",
  top: 0,
  left: 0,
  height: "100vh",
  width: "100vw",
  zIndex: 1101, //headerのzIndexが1100
  backgroundColor: "rgba(209, 209, 209, 0.5)",
})

const RootGrid = styled(Grid)({
  height: "100vh",
  width: "100vw",
})

const APILoading = () => {
  const { isApiLoading } = useApiLoading()
  if (isApiLoading) {
    return (
      <ProgressPaper>
        <RootGrid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            <CircularProgress />
          </Grid>
        </RootGrid>
      </ProgressPaper>
    )
  }
  return null
}

export default APILoading
